import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    forceRejectReason: false,
    multipleRolesCombinedBehavior: "",
    loginToken: "",
    trinFormsUrl: "",
    useRecommendedRolePermissions: false,
    displayAICapturePopup: true,
    loaded: false
  }
};
const systemSettingInfoSlice = createSlice({
  name: "systemSettingInfo",
  initialState,
  reducers: {
    getSystemSettings: (state, action) => {
      state.value = {
        forceRejectReason: action.payload.forceRejectReason,
        multipleRolesCombinedBehavior: action.payload.multipleRolesCombinedBehavior,
        loginToken: action.payload.loginToken,
        trinFormsUrl: action.payload.trinFormsUrl,
        useRecommendedRolePermissions: action.payload.useRecommendedRolePermissions,
        displayAICapturePopup: action.payload.displayAICapturePopup,
        loaded: true
      };
    }
  }
});
export const { getSystemSettings } = systemSettingInfoSlice.actions;
export default systemSettingInfoSlice.reducer;
